// extracted by mini-css-extract-plugin
module.exports = {"title":"LoginModal_title__1jqUU","label":"LoginModal_label__AbBEO","btn":"LoginModal_btn__K2ohB"};